module.exports = __webpack_public_path__ + "media/images/amenities_icons/mentor_program-2b0ca8240fa14e811b3e48f2fffb013f.svg";